import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getDefaultName, mediaSrc } from '../../utils';
import { ApiHttpService } from '../../utils/http/api';

const DEFAULT_IMAGE = '/assets/images/default.png';

export default function RatingsSelectorContent() {
    const [pageloading, setPageLoading] = useState(false);
    const [courses, setCourses] = useState([]);

    useEffect(() => {
        setPageLoading(true);
        ApiHttpService.loadCoursesForAdmin().then((data) => {
            setCourses(data?.results || []);
            setPageLoading(false);
        });
    }, []);

    return (
        <div className="content-wrapper">
            <section className="content">
                <div className="row">
                    <div className="col-md-12">
                        <div className="box box-primary">
                            <div className="box-header with-border">
                                <h3 className="box-title mt-5">Select Contest for Ratings</h3>
                            </div>
                            <div className="box-body">
                                {pageloading && (
                                    <p className="text-center" style={{ color: '#7a9ab8' }}>
                                        Loading…
                                    </p>
                                )}
                                <div className="talent-cards-grid course-cards-grid">
                                    {courses.map((item, index) => (
                                        <div
                                            key={item.id}
                                            className="talent-card-col"
                                            style={{ animationDelay: `${Math.min(index * 42, 480)}ms` }}
                                        >
                                            <div className="talent-card course-card-item">
                                                <a href={`/cms/ratings/${item.id}`} className="course-card-media">
                                                    <img
                                                        className="talent-card-img"
                                                        src={mediaSrc(item.image, DEFAULT_IMAGE)}
                                                        alt={getDefaultName(item.names)}
                                                    />
                                                </a>
                                                <a href={`/cms/ratings/${item.id}`} className="course-card-title-link">
                                                    {getDefaultName(item.names)}
                                                </a>
                                                <div className="course-card-pills">
                                                    <div className="course-card-pills-row">
                                                        <Link
                                                            title="Contest participants"
                                                            className="talent-card-count course-card-pill"
                                                            to={`/cms/coursedetails/${item.id}`}
                                                        >
                                                            <i className="fa fa-users" aria-hidden />
                                                            {(item.number_of_participants ?? 0).toLocaleString()}
                                                        </Link>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
}
